import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiClient from '../api/ApiClient';

const userAPI = createSlice({
	name: 'userAPI',
	initialState: {
		list: [],
		roles: [],
		fullNames: [],
		companies: [],
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchUserPage.fulfilled, (state, action) => {
				state.list = action.payload;
			})
			.addCase(fetchUserRoles.fulfilled, (state, action) => {
				state.roles = action.payload;
			})
			.addCase(fetchUserFullNames.fulfilled, (state, action) => {
				state.fullNames = action.payload;
			})
			.addCase(fetchUserCompanies.fulfilled, (state, action) => {
				state.companies = action.payload;
			});
	},
});

export const fetchUserPage = createAsyncThunk(
	'user/fetch/page',
	async ({ page, filter, sort }) => {
		const response = await apiClient.get(
			`/api/profile-admin/users`,
			null,
			page,
			filter,
			sort
		);
		return response.data;
	}
);

export const fetchUserRoles = createAsyncThunk(
	'user/fetch/user-roles',
	async ({ page, filter, sort }) => {
		const response = await apiClient.get(
			`/api/profile-admin/roles`,
			null,
			page,
			filter,
			sort
		);

		if (response.data.content?.length > 0) {
			const _response = [];
			response.data.content.map((item, index) => {
				_response.push({
					code: index,
					name: item,
				});
			});
			response.data.content = _response;
		}

		return response.data;
	}
);

export const fetchUserFullNames = createAsyncThunk(
	'user/fetch/user-full-names',
	async ({ page, filter, sort }) => {
		const response = await apiClient.get(
			`/api/profile-admin/user-full-names`,
			null,
			page,
			filter,
			sort
		);

		if (response.data.content?.length > 0) {
			const _response = [];
			response.data.content.map((item, index) => {
				_response.push({
					code: index,
					name: item,
				});
			});
			response.data.content = _response;
		}

		return response.data;
	}
);

export const fetchUserCompanies = createAsyncThunk(
	'user/fetch/user-companies',
	async ({ page, filter, sort }) => {
		const response = await apiClient.get(
			`/api/profile-admin/companies`,
			null,
			page,
			filter,
			sort
		);

		if (response.data.content?.length > 0) {
			const _response = [];
			response.data.content.map((item, index) => {
				_response.push({
					code: index,
					name: item,
				});
			});
			response.data.content = _response;
		}

		return response.data;
	}
);

export default userAPI.reducer;
